import { Link } from "react-router-dom";
import { ROUTES } from "./routes";

function OrbContent() {
  return (
    <>
      <span className="nexus-nav-orb-halo" aria-hidden />
      <span className="nexus-nav-orb-energy" aria-hidden />
      <span className="nexus-nav-orb-core">
        <span className="nexus-nav-orb-prefix">5X</span>
        <span className="nexus-nav-orb-brand">NEXUS</span>
      </span>
    </>
  );
}

export default function NexusNavOrb() {
  return (
    <Link
      to={ROUTES.dashboard}
      className="nexus-nav-orb focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-400/50 rounded-full"
      title="Go to NEXUS command center"
      aria-label="Go to NEXUS command center"
    >
      <OrbContent />
    </Link>
  );
}
